module.exports = __webpack_public_path__ + "static/media/nifco_logo_light.f319fb54.png";